
import { Vue, Component, VModel, Prop } from "vue-property-decorator";

@Component({ name: "b-tabs" })
export default class BTabs extends Vue {
  @VModel({ type: Number, default: -1 }) selected!: number;
  @Prop(Array) readonly items!: string[];
}
